import React from 'react';
import LinkifyReact from 'linkify-react';
import 'linkifyjs';
import { Options } from 'linkifyjs';
import { PrettyUrlOptions, prettyUrl } from '@shared/utils/formatting/prettyUrl/prettyUrl.formatter';

type LinkifyReactOptions = Options;

enum LinkifyTypes {
  url = 'url',
  email = 'email'
}

const getLinkifyOptions: (prettyUrlFormat?: boolean, prettyUrlOptions?: PrettyUrlOptions) => Partial<LinkifyReactOptions> = (
  prettyUrlFormat = true,
  prettyUrlOptions?: PrettyUrlOptions
) => {
  const linkifyOptions = {
    nl2br: true,
    ignoreTags: ['a', 'button'],
    target: {
      url: '_blank'
    },
    attributes: {
      rel: 'nofollow'
    },
    format: (value: string, type: LinkifyTypes) => {
      switch (type) {
        case LinkifyTypes.url:
          return prettyUrlFormat ? prettyUrl(value, prettyUrlOptions) : value;
        default:
          return value;
      }
    }
  };

  return linkifyOptions;
};

type LinkifyUrlsAndEmailProps = { prettyUrlFormat?: boolean; prettyUrlOptions?: PrettyUrlOptions };

export const LinkifyUrlsAndEmails: React.FC<LinkifyUrlsAndEmailProps> = ({ children, prettyUrlFormat, prettyUrlOptions }) => {
  return <LinkifyReact options={getLinkifyOptions(prettyUrlFormat, prettyUrlOptions)}>{children}</LinkifyReact>;
};
